var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressBarHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 8.65625H7.6875V4.79688C7.6875 4.03516 8.32227 3.375 9.10938 3.375H13.5781C15.2539 3.375 16.625 4.74609 16.625 6.42188V11.9062C16.625 12.2617 16.3457 12.5156 16.0156 12.5156C15.6602 12.5156 15.4062 12.2617 15.4062 11.9062V9.875H1.59375V11.7031C1.59375 12.0586 1.31445 12.3125 0.984375 12.3125C0.628906 12.3125 0.375 12.0586 0.375 11.7031V1.54688C0.375 1.2168 0.628906 0.9375 0.984375 0.9375C1.31445 0.9375 1.59375 1.2168 1.59375 1.54688V8.65625ZM13.5781 4.59375H9.10938C8.98242 4.59375 8.90625 4.69531 8.90625 4.79688V8.65625H15.4062V6.42188C15.4062 5.43164 14.5684 4.59375 13.5781 4.59375ZM6.875 5.60938C6.875 6.85352 5.85938 7.84375 4.64062 7.84375C3.39648 7.84375 2.40625 6.85352 2.40625 5.60938C2.40625 4.39062 3.39648 3.375 4.64062 3.375C5.85938 3.375 6.875 4.39062 6.875 5.60938ZM4.64062 4.59375C4.05664 4.59375 3.625 5.05078 3.625 5.60938C3.625 6.19336 4.05664 6.625 4.64062 6.625C5.19922 6.625 5.65625 6.19336 5.65625 5.60938C5.65625 5.05078 5.19922 4.59375 4.64062 4.59375Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarHotel);
export default __webpack_public_path__ + "static/media/ProgressBarHotel.a41b70b0d701c3a85527f9a0ecf0af70.svg";
export { ForwardRef as ReactComponent };